require("./threepl-services-table-item.scss");

import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {ThreePLServiceDetails} from "../../models/threepl-service-details.model";

@Component({
  selector: "app-threepl-services-table-item",
  templateUrl: "./threepl-services-table-item.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServicesTableItemComponent {
  readonly service = input.required<ThreePLServiceDetails>();
  readonly columns = input<Record<string, boolean>>({});
}
